import { OFFRE_REDUCER_NAME } from '../offre';
import { OfferStateType } from '../offre/types';

export const cachedSubTypesOptionsSelector = (s: OfferStateType) =>
    s[OFFRE_REDUCER_NAME].cached.subTypes;
